import { React, fetchApi, PT } from '@gasbuddy/react';
import { Button, Modal, Header, Icon, Dimmer, Loader, Card } from 'semantic-ui-react';

import Style from './style.css';
import { OfferDetail } from './OfferDetail';

const Offer = ({ offer, onClick }) => (
  <Card onClick={() => onClick(offer)}>
    <Card.Content>
      <div><img src={`https://images.gasbuddy.io/autox70/${offer.partner.image_url}`} alt="Offer Hero" /></div>
      <div className={Style.name}>{offer.partner.name}</div>
      <div className={Style.amount}>{offer.reward_text}</div>
      <div className={Style.footer}>GasBack</div>
    </Card.Content>
  </Card>
);

Offer.propTypes = {
  offer: PT.shape({}).isRequired,
  onClick: PT.func.isRequired,
};

export class SavingsTab extends React.Component {
  state = {};

  onChange = (f, v) => { this.setState({ [f]: v }); }

  getOffers = () => {
    this.setState({ opened: true, loading: true }, async () => {
      const { body: { offers } } = await fetchApi({
        url: '/loyalty/offers/simulate',
        body: {},
      });
      this.setState({ offers, loading: false });
    });
  }

  onClick = offer => this.setState({ offer });

  render() {
    const {
      opened, loading, offers, offer,
    } = this.state;
    return (
      <Modal
        style={{ maxWidth: 600, marginLeft: -300 }}
        open={opened}
        closeIcon
        onClose={() => this.setState({ opened: false })}
        trigger={(
          <Button
            size="small"
            onClick={this.getOffers}
            content="View Savings Tab"
            color="blue"
          />
        )}
      >
        <Header content="Savings Tab" />
        <Modal.Content scrolling>
          {offer && (
            <Modal
              open
              closeIcon
              style={{ maxWidth: 600, marginLeft: -300 }}
              onClose={() => this.setState({ offer: null })}
            >
              <Modal.Content
                scrolling
              >
                <OfferDetail offer={offer} />
              </Modal.Content>
            </Modal>
          )}
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <p>
              This view is similar to the savings tab as it would appear for you
              in the app.
            </p>
            <div className={Style.savingsTab}>
              {(offers || [])
                .reduce((result, value, index, array) => {
                  if (index % 2 === 0) {
                    result.push([array[index], array[index + 1]]);
                  }
                  return result;
                }, [])
                .map(([offer1, offer2]) => (
                  <Card.Group key={offer1.offer_id} itemsPerRow={2}>
                    <Offer offer={offer1} onClick={this.onClick} />
                    {offer2 && <Offer offer={offer2} onClick={this.onClick} />}
                  </Card.Group>
                ))}
            </div>
          </Dimmer.Dimmable>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={this.getOffers}>
            <Icon name="refresh" />
            {' '}
            Refresh
          </Button>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
